import { UPDATE_COMPONENT_STATE } from './types'

export function setComponentState(componentId, componentState) {
  return {
    type: UPDATE_COMPONENT_STATE,
    payload: { componentState, componentId },
  }
}
